/* Galeria de producto: swipe nativo en movil, crossfade en escritorio, visor con zoom */
(function () {
  function init() {
    [].forEach.call(document.querySelectorAll('[data-lp-pg]'), function (g) {
      var track = g.querySelector('.lp-pg__track');
      var slides = [].slice.call(g.querySelectorAll('.lp-pg__slide'));
      var thumbs = [].slice.call(g.querySelectorAll('[data-pg-thumb]'));
      var curEl = g.querySelector('[data-pg-cur]');
      var data = [].map.call(g.querySelectorAll('.lp-pg__data li'), function (li) {
        return { full: li.getAttribute('data-full'), thumb: li.getAttribute('data-thumb'), alt: li.getAttribute('data-alt') };
      });
      var mq = window.matchMedia('(min-width: 1000px)');
      var cur = 0, raf = 0;

      function set(i, fromScroll) {
        i = (i + slides.length) % slides.length;
        cur = i;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); t.setAttribute('aria-current', on ? 'true' : 'false'); });
        if (curEl) curEl.textContent = i + 1;
        if (!fromScroll && !mq.matches) track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { set(i); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!n) return; e.preventDefault(); set(i + n); var nt = thumbs[cur]; if (nt) nt.focus();
        });
      });
      g.querySelector('[data-pg-prev]').addEventListener('click', function () { set(cur - 1); });
      g.querySelector('[data-pg-next]').addEventListener('click', function () { set(cur + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); set(cur + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); set(cur - 1); }
        if (e.key === 'Enter') openLb(cur);
      });
      track.addEventListener('scroll', function () {
        if (mq.matches) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var x = track.scrollLeft + slides[0].offsetLeft, best = 0, d = 1e9;
          slides.forEach(function (s, k) { var dd = Math.abs(s.offsetLeft - x); if (dd < d) { d = dd; best = k; } });
          if (best !== cur) set(best, true);
        });
      }, { passive: true });

      /* ---------- visor ---------- */
      var dlg = g.querySelector('.lp-pg__dialog');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var img = dlg.querySelector('.lp-pg__lbfig img');
      var fig = dlg.querySelector('.lp-pg__lbfig');
      var strip = dlg.querySelector('.lp-pg__lbstrip');
      var lbCur = dlg.querySelector('[data-lb-cur]');
      var li = 0, zoomed = false, opener = null, startX = null, dragged = false;
      data.forEach(function (d, k) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'lp-pg__lbthumb'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', 'Photo ' + (k + 1));
        var im = document.createElement('img'); im.src = d.thumb; im.alt = ''; im.width = 56; im.height = 56; im.loading = 'lazy';
        b.appendChild(im); b.addEventListener('click', function () { showLb(k); }); strip.appendChild(b);
      });
      var sthumbs = [].slice.call(strip.children);
      function zoom(on, x, y) {
        zoomed = on; fig.classList.toggle('is-zoomed', on);
        if (on) { img.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%'; }
      }
      function showLb(k) {
        li = (k + data.length) % data.length; zoom(false);
        img.classList.remove('is-in'); img.src = data[li].full; img.alt = data[li].alt;
        requestAnimationFrame(function () { img.classList.add('is-in'); });
        lbCur.textContent = li + 1;
        sthumbs.forEach(function (b, j) { b.classList.toggle('is-active', j === li); b.setAttribute('aria-selected', j === li ? 'true' : 'false'); });
        var a = sthumbs[li]; if (a && a.scrollIntoView) a.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        var nx = new Image(); nx.src = data[(li + 1) % data.length].full;
      }
      function openLb(k) { opener = document.activeElement; showLb(k); dlg.showModal(); document.documentElement.style.overflow = 'hidden'; }
      g.querySelector('[data-pg-open]').addEventListener('click', function () { openLb(cur); });
      track.addEventListener('click', function (e) { if (mq.matches || !dragged) { if (e.target.closest('.lp-pg__slide')) openLb(cur); } });
      [].forEach.call(g.querySelectorAll('[data-pg-open]'), function (b) {
        b.addEventListener('click', function () { var v = b.getAttribute('data-pg-open'); openLb(v === '' || v === null ? cur : parseInt(v, 10)); });
      });
      dlg.querySelector('[data-lb-close]').addEventListener('click', function () { dlg.close(); });
      dlg.querySelector('[data-lb-prev]').addEventListener('click', function () { showLb(li - 1); });
      dlg.querySelector('[data-lb-next]').addEventListener('click', function () { showLb(li + 1); });
      dlg.addEventListener('close', function () { zoom(false); document.documentElement.style.overflow = ''; if (opener && opener.focus) opener.focus(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') showLb(li + 1);
        if (e.key === 'ArrowLeft') showLb(li - 1);
      });
      fig.addEventListener('click', function (e) {
        var r = img.getBoundingClientRect();
        zoom(!zoomed, Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)), Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)));
      });
      fig.addEventListener('mousemove', function (e) {
        if (!zoomed) return; var r = fig.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      fig.addEventListener('touchmove', function (e) {
        if (!zoomed) return; var t = e.touches[0], r = fig.getBoundingClientRect();
        img.style.transformOrigin = ((t.clientX - r.left) / r.width * 100) + '% ' + ((t.clientY - r.top) / r.height * 100) + '%';
      }, { passive: true });
      dlg.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      dlg.addEventListener('touchend', function (e) {
        if (startX === null || zoomed) { startX = null; return; }
        var dx = e.changedTouches[0].clientX - startX; startX = null;
        if (Math.abs(dx) > 60) showLb(li + (dx < 0 ? 1 : -1));
      });
      track.addEventListener('touchmove', function () { dragged = true; }, { passive: true });
      track.addEventListener('touchstart', function () { dragged = false; }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
